import { circIn } from "motion";
import hand_folding from "./images/hand-folding.BKofoyJW_ZrF9vd.webp";
import profile from "./images/O0QNpSC6pK1HJWBaRMnB4CRds.png";
import { motion } from "motion/react";

const Main = () => {
  return (
    <div className="flex gap-x-6 mt-16">
      <div className="w-full lg:w-8/12 p-0.5 bg-gradient-to-b from-[#272727] to-[#111111] rounded-[40px]">
        <div
          initial={{ scale: 0 }}
          animate={{ transition: { duration: 0.4, timing: circIn }, scale: 1 }}
          className="w-full bg-[#0D0D0D] rounded-[40px] text-white p-14 h-full items-center flex"
        >
          <div className="w-full">
            <div className="flex justify-between w-full">
              <div className="flex items-center">
                <img src={profile} alt="icon" className="w-9" />
                <div className="px-6">
                  <p className="pacifico-regular font-normal text-white text-lg tracking-wider">
                    Divakar Perla
                  </p>
                  <p className="text-xs mt-1 text-[#9CA3AF] tracking-wider">
                    A Technology Lover and Solo Traveler
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.linkedin.com/in/divakar-reddy-pv-b3794116b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  className="px-2 py-1 border-[#272727] border-2 rounded-xl"
                >
                  <i className="bi bi-linkedin text-white text-lg"></i>
                </a>
                <a
                  href="https://x.com/pvdiva4552"
                  target="_blank"
                  className="px-2 py-1 border-[#272727] border-2 rounded-xl"
                >
                  <i className="bi bi-twitter text-white text-lg"></i>
                </a>
                <a className="px-2 py-1 border-[#272727] border-2 rounded-xl">
                  <a href="mailto:pvdiva4559@gmail.com?subject=Hello&body=I'd%20love%20to%20get%20in%20touch!">
                    <p className="text-lg px-3 whitespace-nowrap">
                      Get In Touch
                    </p>
                  </a>
                </a>
              </div>
            </div>
            <div className="text-5xl mt-8 ">
              A Frontend-focussed full stack developer
            </div>
            <p className="text-lg mt-8 text-[#9CA3AF] tracking-wider">
              Hello! I’m Divakar, a full-stack developer with a strong passion
              for AI and Blockchain etc.
            </p>
          </div>
        </div>
      </div>
      <div className=" w-4/12 p-0.5 lg:block hidden bg-gradient-to-b from-[#272727] to-[#111111] rounded-[40px]">
        <div className="w-full h-full flex items-end bg-[url('./images/star-background.png')] bg-cover bg-center rounded-[40px] text-white img-after">
          <img src={hand_folding} className="w-10/12 mx-auto" />
        </div>
      </div>
    </div>
  );
};

export default Main;
